import { useEffect } from "react";

export function useDesktopAutoFocusTextInput(inputRef, options = {}) {
  const { enabled = true, isMobile = false } = options;

  useEffect(() => {
    if (!enabled || isMobile) {
      return undefined;
    }

    const focusInput = () => {
      inputRef?.current?.focus?.();
    };

    if (typeof requestAnimationFrame === "function") {
      const rafId = requestAnimationFrame(focusInput);

      return () => {
        cancelAnimationFrame(rafId);
      };
    }

    const timeoutId = setTimeout(focusInput, 0);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [enabled, inputRef, isMobile]);
}
